import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const PregnancyCategoryDBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-amber-500 text-white">
      {t('component:badge.pregnancyCategoryLevel', { category: 'D' })}
    </Badge>
  );
};
